import type { FunctionComponent } from "react";

import type { Props as BaseLinkProps } from "scmp-app/components/common/base-link";
import { tracking } from "scmp-app/data";
import { page as postiesParentsPage } from "scmp-app/pages/posties/parents";

import {
  ButtonContainer,
  Container,
  Description,
  ImageContainer,
  StyledButton,
  TextContainer,
  Title,
} from "./styles";

export type Props = {
  buttonProps: BaseLinkProps;
  buttonText?: string;
  className?: string;
  description: string;
  image: StaticImageData;
  title: string;
};

export const WeHaveSoMuchForYouItem: FunctionComponent<Props> = ({
  buttonProps,
  buttonText,
  className,
  description,
  image,
  title,
}) => {
  const { query } = postiesParentsPage.route({});

  const postiesBrochureHomepageGetEvenMoreWithPostiesQueryParameters = {
    module: tracking.module.GetEvenMoreWithPosties,
    pgtype: tracking.pageType.Brochure,
  };

  return (
    <Container className={className}>
      <ImageContainer>
        <img alt={image.alt} src={image.src} />
      </ImageContainer>
      <TextContainer>
        <Title>{title}</Title>
        <Description>{description}</Description>
        {buttonText && (
          <ButtonContainer>
            <StyledButton
              query={{ ...query, ...postiesBrochureHomepageGetEvenMoreWithPostiesQueryParameters }}
              variant="link"
              {...buttonProps}
            >
              {buttonText}
            </StyledButton>
          </ButtonContainer>
        )}
      </TextContainer>
    </Container>
  );
};

WeHaveSoMuchForYouItem.displayName = "WeHaveSoMuchForYouItem";
